import { createContext, useContext, useEffect, useState } from "react";

const CONSENT_KEY = "cookie_consent";
const ConsentContext = createContext(null);

export function ConsentProvider({ children }) {
  const [consent, setConsent] = useState(() => localStorage.getItem(CONSENT_KEY)); 
  // null = not decided, "accepted" or "declined"

  useEffect(() => {
    if (consent) localStorage.setItem(CONSENT_KEY, consent);
  }, [consent]);

  return (
    <ConsentContext.Provider value={{ consent, setConsent }}>
      {children}
    </ConsentContext.Provider>
  );
}

export function useConsent() {
  const ctx = useContext(ConsentContext);
  if (!ctx) throw new Error("useConsent must be used within ConsentProvider");
  return ctx;
}